import * as React from 'react'

import { Button, ButtonProps } from 'components/Button/Button'
import { PopoutWindow } from 'components/PopoutWindow'

export interface Props extends ButtonProps {
  caseId?: string
  classType?: 'msa' | 'msp'
}

export const createReturnUrl = (isMSA: boolean, caseId?: string) => {
  const envUrl = isMSA ? process.env.REACT_APP_WCMSA_RETURN_URL : process.env.REACT_APP_MSPRP_RETURN_URL
  const url = new URL(envUrl ?? `https://www.cob.cms.hhs.gov/${isMSA ? 'WCMSA/mmLogin' : 'MSPRP/beneLogin'}`)
  // Case id needs to be a part of the return url itself, not a part of the bsi url
  if (caseId) {
    url.searchParams.append('CaseId', caseId)
  }
  return url.toString()
}

const createBsiUrl = (caseId?: string, classType?: 'msa' | 'msp') => {
  const isMSA = classType === 'msa'
  const urlSwap = isMSA ? process.env.REACT_APP_WCMSA_BSI_URL : process.env.REACT_APP_MSPRP_BSI_URL
  const returnSwap = createReturnUrl(isMSA, caseId)

  const bsiUrl = new URL(urlSwap || `https://bsi.medicare.gov/fed/idp/initiatesso?providerid=${isMSA ? 'WCMSA_PRO' : 'MSPRP_PRO'}`)
  bsiUrl.searchParams.append('returnurl', returnSwap)

  return bsiUrl
}

export const BsiButton: React.FC<Props> = ({
  caseId,
  classType,
  children,
  onClick,
  ...rest
}) => {
  const [popoutOpen, setPopoutOpen] = React.useState<boolean>(false)
  const [shouldReRender, setShouldReRender] = React.useState<boolean>(false)

  const [win, setWindow] = React.useState<Window | null>(null)

  const bsiUrl = createBsiUrl(caseId, classType)
  return (
    <>
      {popoutOpen && (
        <PopoutWindow
          setWindow={setWindow}
          shouldReRender={shouldReRender}
          windowArgs={{
            title: 'MSPRP',
            features: 'height=730,width=680,scrollbars=1,left=50,top=100'
          }}
          formSubmitData={{
            hasRedirect: true,
            action: bsiUrl.href
          }}
          persistOnUnmount
        />
      )}
      <Button
        onClick={(e) => {
          if (win && !win.closed) {
            // If the window is already open somewhere
            win.focus()
          } else if (win) {
            // We just force a rerender on the popout window component
            setShouldReRender(!shouldReRender)
          } else {
            setPopoutOpen(true)
          }
          onClick?.(e)
        }}
        {...rest}
      >
        {children}
      </Button>
    </>
  )
}

export default BsiButton
